@if (position) {
  <td class="whitespace-nowrap py-4 pr-3 pl-3 text-sm font-medium text-fg-primary">
    {{ position.displayName }}
  </td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-fg-secondary text-right">
    @if (position.quantity !== null) {
      {{ position.quantity | stringToNumber }}
    }
  </td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-fg-secondary text-left">{{ unitText }}</td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-fg-secondary text-right tabular-nums">
    @if (position.unitPrice !== null) {
      {{ position.unitPrice | formatAmount }}
    }
  </td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-fg-secondary text-right">
    {{ position.vatRate | formatPercent }}%
  </td>
  <td
    class="whitespace-nowrap px-3 py-4 text-sm font-medium text-fg-secondary text-right tabular-nums"
  >
    {{ position.totalPrice | formatAmount }}
  </td>
  <td class="whitespace-nowrap px-3 py-4">
    <div class="flex items-center justify-end gap-2">
      <button
        [disabled]="isDisabled"
        class="flex items-center text-fg-faint hover:text-fg-subtle disabled:hover:text-fg-faint"
        (click)="editPosition.emit(position)"
      >
        <app-ng-icon name="heroPencil"></app-ng-icon>
      </button>
      <button
        [disabled]="isDisabled"
        class="flex items-center text-fg-faint hover:text-fg-subtle disabled:hover:text-fg-faint"
        (click)="deletePosition.emit(position)"
      >
        <app-ng-icon name="heroTrash"></app-ng-icon>
      </button>
    </div>
  </td>
}
